import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorkerRegistration from 'serviceWorkerRegistration';
import { envServices } from 'utils/EnvServices';
import { versionUpdateServices as serviceWorkersUpdateServices } from 'utils/ServiceWorkerUpdateServices';

import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';

envServices.validate();
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// TODO: Temporary solution
// Further can be extended to react context
serviceWorkersUpdateServices.subscribeForUpdates(() => {
  const message = 'New version is available. Do you want to update?';
  if (window.confirm(message)) {
    serviceWorkersUpdateServices.activateLatestVersion();
  }
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    serviceWorkersUpdateServices.setRegistration(registration);
  },
});

// Check for updates on page reload
serviceWorkersUpdateServices.checkForUpdates();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
